const validationMessages = {
  somethingWentWrong: 'Something went wrong.',
  isRequired: ' is required.',
  charRange: 'At least 8 characters but no more than 20.',
  upperLowerCase: 'At least one upper case and one lower case letter.',
  aleastNumberAndSpecialChar:
    'At least one number and special character: ! ? @ (no others allowed)',
  noCharMoreThanTwice: 'No character is used more than twice in a row.',
  doesNotContains:
    'Doesn’t contain your user ID.',
  notValidFormat: 'This is not a valid format!',
  passwordNotMatched: 'Password does not match',
  passwordReset: 'Password reset successfully',
  invalidDate: 'Invalid date',
  dateRequirement: 'Date is not valid as per requirement',
  loginFailed: 'Incorrect user ID and/or password',
  doesNotContainFirstname: 'Does not include your first name',
  doesNotContainLastname: 'Does not include your last name'
};

export default validationMessages;
